import { getGlobalSettingsAccountMailboxInfo, getCoprincipalMailboxInfoForMailboxInfo, } from "owa-account-source-list-store";
import { isLocalDataBackedMailboxInfo } from "owa-account-source-list/lib/utils/isLocalDataBackedAccount";
import { type MailboxInfo } from "owa-client-types";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { isGroupMailboxInfo } from "owa-client-types/lib/GroupMailboxInfo";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";

export function getMailboxInfoForMeControl(): MailboxInfo {
    const mailboxInfo = getModuleContextMailboxInfo();
    if (isLocalDataBackedMailboxInfo(mailboxInfo) ||
        isGroupMailboxInfo(mailboxInfo) ||
        isUnifiedInboxMailboxInfo(mailboxInfo)) {
        // For local data backed (PST), Group Mailboxes or UnifiedInbox we want to use the global mailbox info
        return getGlobalSettingsAccountMailboxInfo();
    }
    
    // For other mailbox types (UserMailbox, SharedMailbox, ArchiveMailbox, etc) we want to use the coprincipal mailbox
    return (getCoprincipalMailboxInfoForMailboxInfo(mailboxInfo) ??
        getGlobalSettingsAccountMailboxInfo());
}
